export default{
    filters:{
        hotjocktrain:function(value){
            if(value.includes('(') && !value.includes('/')){
                var string = value.split(' ')
                 var newstring=[...string]
                var temp= newstring.splice(0,1)
                var init= newstring[newstring.length-1]
                newstring.pop()
                name=temp+' ' +init+ ' ' +newstring
                newstring.pop()
                if(name.includes(',')){
                   var midname= name.split(',')[1]
                   if(midname.length>1){
                        return name.replace(',',' ').toUpperCase()
                   }
                   else{
                       name=temp+' ' +init+' '+ midname +' ' +newstring
                       return name.toUpperCase()
                   }
                }
                else{
                    return name.toUpperCase()
                }
             }
             else if(!value.includes('(') && !value.includes('/')){
                var string = value.split(' ')
                 var newstring=[...string]
                 var init= newstring[newstring.length-1]
                 newstring.pop()
                 name=init+ ' ' +newstring
                 newstring.pop()
                 if(name.includes(',')){
                    var midname= name.split(',')[1]
                    if(midname.length>1){
                         return name.replace(',',' ').toUpperCase()
                    }
                    else{
                        name=init+' '+ midname +' ' +newstring
                        return name.toUpperCase()
                    }
                 }
                 else{
                     return name.toUpperCase()
                 }
             }
             else{
                 return value.toUpperCase()
             }

        },
        jtindex:function(value){
            value=value.toString()
            if(value!=null && ( !value.includes('*'))){
                if (/\s/.test(value)) {
                    var str= value.split(' ')
                      if (str.length >=2){
                       var init= str[str.length -1 ] ; 
                       str.pop() ; 
                       
                       var name= str.join(" ") ;
                        var res=init + ' ' + name

                            return res.toUpperCase()
                      }
                      else{
                        return value.toUpperCase()
                      }
                     
                  }   
        }
        else {
            return value.toUpperCase()
        }
        },
       
        init:function(value){
            value=value.toString()
            if(value!=null && (value.split(" ")[0].length>1 && !value.includes('St') && !value.includes('/') && !value.includes('SCRATCHED'))){
              var val=value.split(" ")[0]
              var lname=value.split(" ")[1]
              var init=val.charAt(0)
                return init +' '+ lname
            }
            else if(value!=null && (value.split(" ")[0].length>1 && value.includes('St') && !value.includes('/')&& !value.includes('SCRATCHED'))){
                var title=value.split(" ")[0]
                var val=value.split(" ")[1]
                var init=val.charAt(0)
              
                return title + ' '+ init + value.replace(title,'').replace(val,'')
            }
            else if(value!=null && value.includes('/')){
                return value
            }
            else{
                return value
            }
                
        },
        jockeyinit:function(value){
            value=value.toString()
            if(value!=null && value.includes('Veale S')){
                value='S Veale'
                return value
            }
            else{
                return value
            }
        },
        winner:function(value){
            value=value.toString()
            if(value!=null && value.includes('#')){
                value=value.replace('#','')
            }
            return value
        },
    }
}